import { useMemo, useState } from 'react';
//API
import { useBetRanking } from '@/api/bets';
//Enum
import { PeriodTabsOptions } from '@/enums/filter-by-period';
//Components
import GameDetailsContentCard from '../Card';
import { ErrorCard, NoDataComponent } from '@starsoft/common/components';
//Hook
import { useGamesBySlugWithQueryParams } from '@/hooks/games/useGamesBySlugWithQueryParams';
import usePeriodId from '@/hooks/usePeriodId';
//Filter - By Period
import { GameDetailsContentRendererProps } from './props';

import GameDetailsContentRendererContent from './Content';
import { DetailedBet } from '@/models/detailed-bet';

export default function GameDetailsContentRenderer({
  typeId,
}: GameDetailsContentRendererProps) {
  const { game } = useGamesBySlugWithQueryParams();
  const [tabs, setTabs] = useState<PeriodTabsOptions>(PeriodTabsOptions.OneDay);
  const { periodId } = usePeriodId(tabs);

  const {
    data: bets,
    error,
    isPending: isLoading,
    refetch,
  } = useBetRanking({
    periodId,
    limit: 3,
    gameId: game?.id,
    typeId: typeId,
  });

  const Cards = useMemo(
    () =>
      bets?.data?.map((bet, index) => (
        <GameDetailsContentCard
          bet={bet}
          position={index + 1}
          key={`game-result-card-${bet?.id}`}
        />
      )),
    [bets],
  );

  const noData = Cards?.length == 0 && !isLoading;

  const Skeletons = useMemo(
    () =>
      Array.from({ length: 6 })?.map((_, index) => (
        <GameDetailsContentCard
          bet={{} as DetailedBet}
          position={index + 1}
          key={`game-result-card-${index}-skeleton`}
          isLoading
        />
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  return (
    <GameDetailsContentRendererContent
      currentOption={tabs}
      onOptionClick={setTabs}
      isNoData={noData}
    >
      {isLoading ? Skeletons : Cards}
      {noData && <NoDataComponent />}
    </GameDetailsContentRendererContent>
  );
}
